import React, { useContext } from "react";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    height?: number | string;
    maxWidth?: string;
    maxHeight?: string;
};

export const DocLogo: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    return (
        <div className={"DocLogo"}>
            {supplierModel.Doc_Logo?.signedUrl ? (
                <img
                    src={supplierModel.Doc_Logo.signedUrl}
                    height={props.height || 200}
                    style={{ maxWidth: props.maxWidth, maxHeight: props.maxHeight }}
                />
            ) : null}
        </div>
    );
};
